const sizeGuidePopup = document.querySelector(".size-guide")
let isOpeningSizeGuideChat = false
let sizeGuideRequestId = 0

const openSizeGuideModal = (el) => {
  if (!el) return
  el.classList.remove("hidden")
  document.body.style.overflow = "hidden"
  document.body.classList.add("size-guide-opened")
}

const closeSizeGuideModal = (el) => {
  if (!el) return
  sizeGuideRequestId += 1
  el.classList.add("hidden")
  document.body.style.overflow = "auto"
  document.body.classList.remove("size-guide-opened")
}

const setActive = (items, activeEl, activeClass = "active") => {
  items.forEach((x) => x.classList.remove(activeClass))
  if (activeEl) activeEl.classList.add(activeClass)
}

const getSizeGuideChatMessage = (root) => {
  const productTitle = root?.dataset?.sizeGuideProductTitle?.trim()
  const messageParts = []

  if (productTitle) {
    messageParts.push(`I need help with sizing for ${productTitle}.`)
  } else {
    messageParts.push("I need help with sizing.")
  }

  const productUrl = root?.dataset?.sizeGuideProductUrl?.trim()
  if (productUrl) {
    messageParts.push(`Product page: ${productUrl}`)
  }

  return messageParts.join(" ")
}

const getGorgiasChatInitPromise = () => {
  if (window.GorgiasChat?.init) {
    return window.GorgiasChat.init()
  }

  return new Promise((resolve, reject) => {
    let timeoutId

    const cleanup = () => {
      window.removeEventListener("gorgias-widget-loaded", handleWidgetLoaded)
      window.clearTimeout(timeoutId)
    }

    const handleWidgetLoaded = () => {
      cleanup()
      resolve()
    }

    window.addEventListener("gorgias-widget-loaded", handleWidgetLoaded, { once: true })
    timeoutId = window.setTimeout(() => {
      cleanup()
      reject(new Error("Gorgias chat widget did not load in time."))
    }, 10000)
  })
}

const openGorgiasChatAndWait = (chat) => {
  if (typeof chat.isOpen === "function" && chat.isOpen()) {
    return Promise.resolve()
  }

  if (typeof chat.on !== "function") {
    chat.open()
    return new Promise((resolve) => window.setTimeout(resolve, 250))
  }

  return new Promise((resolve, reject) => {
    let settled = false
    let timeoutId

    const cleanup = () => {
      if (typeof chat.off === "function") {
        chat.off("widget:opened", handleOpened)
      }
      window.clearTimeout(timeoutId)
    }

    const handleOpened = () => {
      if (settled) return
      settled = true
      cleanup()
      resolve()
    }

    timeoutId = window.setTimeout(() => {
      if (settled) return
      settled = true
      cleanup()
      reject(new Error("Gorgias chat did not open in time."))
    }, 5000)

    chat.on("widget:opened", handleOpened)
    chat.open()

    if (typeof chat.isOpen === "function" && chat.isOpen()) {
      handleOpened()
    }
  })
}

const openSizingHelpChat = async (root) => {
  if (isOpeningSizeGuideChat) return

  isOpeningSizeGuideChat = true

  try {
    await getGorgiasChatInitPromise()

    const message = getSizeGuideChatMessage(root)
    if (!window.GorgiasChat?.open || !window.GorgiasChat?.setCurrentInput) {
      throw new Error("Gorgias chat API is unavailable.")
    }

    if (typeof window.GorgiasChat.setPage === "function") {
      window.GorgiasChat.setPage("conversation")
    }

    await openGorgiasChatAndWait(window.GorgiasChat)
    // Give the conversation view a moment to mount its input before setting
    // the draft value. This avoids the widget clearing it during navigation.
    await new Promise((resolve) => window.setTimeout(resolve, 100))
    window.GorgiasChat.setCurrentInput(message)
  } catch (error) {
    console.error("Unable to open Gorgias chat from size guide.", error)
  } finally {
    window.setTimeout(() => {
      isOpeningSizeGuideChat = false
    }, 500)
  }
}

const initSizeGuideTabs = (root) => {
  const tabs = Array.from(root.querySelectorAll("[data-size-guide-tab]"));
  const panels = Array.from(root.querySelectorAll("[data-size-guide-panel]"));
  if (!tabs.length || !panels.length) return;

  const showPanel = (key) => {
    tabs.forEach((t) =>
      t.classList.toggle("active", t.getAttribute("data-size-guide-tab") === key)
    );
    panels.forEach((p) =>
      p.classList.toggle("active", p.getAttribute("data-size-guide-panel") === key)
    );
  };

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      const key = tab.getAttribute("data-size-guide-tab");
      showPanel(key);
    });
  });

  showPanel("chart");
};

const initChartSubtabs = (root) => {
  const wrap = root.querySelector(".size-guide__subtabs:not(.size-guide__subtabs--measure)");
  if (!wrap) return;

  const subtabs = Array.from(wrap.querySelectorAll("[data-size-guide-subtab]"));
  const tables = Array.from(root.querySelectorAll("[data-size-guide-table]"));
  if (!subtabs.length || !tables.length) return;

  let activeKey = "all";

  const normalizeKey = (key) => key === "body" ? "all" : key;

  const show = (key) => {
    activeKey = key;

    tables.forEach((table) => {
      const isVisible = key === "all" || table.getAttribute("data-size-guide-table") === key;
      table.classList.toggle("active", isVisible);
    });

    subtabs.forEach((tab) => {
      const isActive = key === "all"
        ? tab.getAttribute("data-size-guide-subtab") === "body"
        : tab.getAttribute("data-size-guide-subtab") === key;
      tab.classList.toggle("active", isActive);
    });
  };

  subtabs.forEach((button) => {
    button.addEventListener("click", () => {
      const key = button.getAttribute("data-size-guide-subtab");
      show(activeKey === normalizeKey(key) ? "all" : normalizeKey(key));
    });
  });

  wrap.addEventListener("click", (event) => {
    if (event.target.closest("[data-size-guide-subtab]")) return;

    show(activeKey === "garment" ? "all" : "garment");
  });

  show("all");
};


const initMeasureSubtabs = (root) => {
  const wrap = root.querySelector(".size-guide__subtabs--measure");
  if (!wrap) return;

  const subtabs = Array.from(wrap.querySelectorAll("[data-size-guide-measure]"));
  const panels = Array.from(root.querySelectorAll("[data-size-guide-measure-panel]"));
  if (!subtabs.length || !panels.length) return;

  let activeKey = "all";

  const normalizeKey = (key) => key === "body" ? "all" : key;

  const show = (key) => {
    activeKey = key;

    subtabs.forEach((b) => {
      const isActive = key === "all"
        ? b.getAttribute("data-size-guide-measure") === "body"
        : b.getAttribute("data-size-guide-measure") === key;
      b.classList.toggle("active", isActive);
    });
    panels.forEach((p) => {
      const isVisible = key === "all" || p.getAttribute("data-size-guide-measure-panel") === key;
      p.classList.toggle("active", isVisible);
    });
  };

  subtabs.forEach((btn) => {
    btn.addEventListener("click", () => {
      const key = btn.getAttribute("data-size-guide-measure");
      show(activeKey === normalizeKey(key) ? "all" : normalizeKey(key));
    });
  });

  wrap.addEventListener("click", (e) => {
    if (e.target.closest("[data-size-guide-measure]")) return;

    show(activeKey === "garment" ? "all" : "garment");
  });

  show("all");

  return { show };
};

const initUnitSwatch = (root) => {
  // IMPORTANT: do it per swatch (in case you have more than one in future)
  const swatches = Array.from(root.querySelectorAll(".guide-swatch"));
  if (!swatches.length) return;

  swatches.forEach((swatch) => {
    const sizeGuideTypes = Array.from(swatch.querySelectorAll(".guide__swatch--type"));
    if (!sizeGuideTypes.length) return;

    const setUnit = (unit) => {
      const allTdSpan = root.querySelectorAll(".guide-table td span");

      sizeGuideTypes.forEach((t) => t.classList.toggle("active", t.getAttribute("data-type") === unit));

      // If you still have slider element in markup, keep it working (safe if hidden)
      const slider = swatch.querySelector(".guide__swatch--slider");
      if (slider) {
        slider.classList.toggle("active-in", unit === "in");
        slider.classList.toggle("active-cm", unit === "cm");
      }

      // Toggle spans: assumes each cell has both .in and .cm spans
      allTdSpan.forEach((span) => {
        if (span.classList.contains("in") || span.classList.contains("cm")) {
          span.classList.toggle("hidden", !span.classList.contains(unit));
        }
      });
    };

    const toggleUnit = () => {
      const active = swatch.querySelector(".guide__swatch--type.active");
      const next = active?.getAttribute("data-type") === "cm" ? "in" : "cm";
      setUnit(next);
    };

    // Click on labels
    sizeGuideTypes.forEach((el) => {
      el.addEventListener("click", () => {
        if (el.classList.contains("active")) return;
        setUnit(el.getAttribute("data-type"));
      });
    });

    // Click on track area (::before/::after visual)
    swatch.addEventListener("click", (e) => {
      if (e.target.closest(".guide__swatch--type")) return;
      toggleUnit();
    });
  });
};


const initMobileColumns = (root = document) => {
  const mobileSizeOptions = Array.from(root.querySelectorAll(".mobile-size-options > div"))

  const showHideMobileSizeColumns = () => {
    if (window.innerWidth < 750) {
      mobileSizeOptions.forEach((option) => {
        if (!option.classList.contains("active")) return
        const thisTableContainer = option.closest(".js-size-table-container")
        if (!thisTableContainer) return
        const colOrder = Number(option.getAttribute("data-order"))
        if (!Number.isInteger(colOrder) || colOrder < 2) return

        thisTableContainer.querySelectorAll(".guide-table tr th:not(:first-child)").forEach((el) => el.classList.add("hidden"))
        thisTableContainer.querySelectorAll(".guide-table tr td:not(:first-child)").forEach((el) => el.classList.add("hidden"))

        thisTableContainer.querySelectorAll(`.guide-table tr th:nth-child(${colOrder})`).forEach((el) => el.classList.remove("hidden"))
        thisTableContainer.querySelectorAll(`.guide-table tr td:nth-child(${colOrder})`).forEach((el) => el.classList.remove("hidden"))
      })
    } else {
      root.querySelectorAll(".guide-table tr th:not(:first-child)").forEach((el) => el.classList.remove("hidden"))
      root.querySelectorAll(".guide-table tr td:not(:first-child)").forEach((el) => el.classList.remove("hidden"))
    }
  }

  if (root._sizeGuideMobileResizeHandler) {
    window.removeEventListener("resize", root._sizeGuideMobileResizeHandler)
  }
  root._sizeGuideMobileResizeHandler = showHideMobileSizeColumns
  window.addEventListener("resize", showHideMobileSizeColumns)

  mobileSizeOptions.forEach((option) => {
    option.addEventListener("click", function () {
      const thisTableContainer = option.closest(".js-size-table-container")
      if (!thisTableContainer) return
      thisTableContainer.querySelectorAll(".mobile-size-options > div").forEach((el) => el.classList.remove("active"))
      this.classList.add("active")
      showHideMobileSizeColumns()
    })
  })

  showHideMobileSizeColumns()
}

const initHowToMeasureButton = (root) => {
  const howToMeasureBtn = root.querySelector(".measuring-guide-btn")
  if (!howToMeasureBtn) return

  howToMeasureBtn.addEventListener("click", function (e) {
    e.preventDefault()

    const tabs = Array.from(root.querySelectorAll("[data-size-guide-tab]"))
    const measureTab = tabs.find((t) => t.getAttribute("data-size-guide-tab") === "measure")
    if (measureTab) measureTab.click()

    const section = root.querySelector("#measuring-guide")
    if (section) section.scrollIntoView({ behavior: "smooth" })
  })
}

const initSizeGuideChatTrigger = (root) => {
  const chatTriggers = Array.from(root.querySelectorAll("[data-size-guide-chat-trigger]"))
  if (!chatTriggers.length) return

  chatTriggers.forEach((trigger) => {
    trigger.addEventListener("click", () => openSizingHelpChat(root))
  })
}

const initNavigateAndOpen = (root) => {
  root.querySelectorAll(".navigate-and-open-size-guide-btn").forEach((btn) => btn.addEventListener("click", function (e) {
    e.preventDefault()
    const targetUrl = this.getAttribute("href")
    if (!targetUrl) return

    try {
      const url = new URL(targetUrl, window.location.origin)
      url.searchParams.set("openSizeGuide", "true")
      window.location.href = url.toString()
    } catch (e2) {
      const separator = targetUrl.includes("?") ? "&" : "?"
      window.location.href = targetUrl + separator + "openSizeGuide=true"
    }
  }))
}

const initOkendoFitReview = () => {
  document.addEventListener("DOMContentLoaded", function () {
    if (!document.querySelector("#size-guide-fit-review  .okeReviews ")) return

    const fitWidgetSizeBar = document.querySelector("#size-guide-fit-review .oke-w-header-content .oke-barBlocks--centered")
    if (fitWidgetSizeBar) {
      const txtEl = document.querySelector("#size-guide-fit-review .oke-w-header-content .oke-attrBar-title .oke-a11yText")
      const precentageText = txtEl ? txtEl.innerText : ""
      if (precentageText.includes("0.0")) {
        const shading = fitWidgetSizeBar.querySelector(".oke-barBlocks-bg-shading")
        const centerLine = fitWidgetSizeBar.querySelector(".oke-barBlocks-bg-centerLine")
        if (shading) {
          shading.style.setProperty("min-width", "30px", "important")
          shading.style.setProperty("transform", "translateX(-13px)", "important")
        }
        if (centerLine) centerLine.style.setProperty("background", "transparent", "important")
      }
    }

    const fitReviewsCount = document.querySelector("#size-guide-fit-review .fit-count")
    const countEl = document.querySelector("#size-guide-fit-review .oke-w-navBar-item-count")
    if (!fitReviewsCount || !countEl) return

    let productCount = Number(String(countEl.innerText || "").replace(/,/g, ""))
    if (!productCount) return

    fitReviewsCount.innerText = productCount === 1 ? `${productCount.toLocaleString()} Review` : `${productCount.toLocaleString()} Reviews`
    if (productCount < 10) return

    const okendoScript = document.querySelector('#size-guide-fit-review [data-oke-metafield-data]')
    const shadingBars = document.querySelectorAll("#size-guide-fit-review .oke-w-barAttributes--stacked .oke-barBlocks-bg-shading")

    if (okendoScript && shadingBars.length) {
      try {
        const jsonData = JSON.parse(okendoScript.textContent || "{}")
        const attributeRatingsValue = jsonData?.reviewAggregate?.attributeRatings?.[0]?.value

        if (typeof attributeRatingsValue === "number") {
          if (attributeRatingsValue > -0.15 && attributeRatingsValue <= 0.15) { // True to Size
            shadingBars.forEach((el) => el.style.setProperty("margin-left", "calc( 50% - 15px)", "important"))
          } else if (attributeRatingsValue > -0.5 && attributeRatingsValue <= -0.15) { // runs a bit small
            shadingBars.forEach((el) => el.style.setProperty("margin-left", "calc( 25% - 15px)", "important"))
          } else if (attributeRatingsValue > -1 && attributeRatingsValue <= -0.5) { // runs small
            shadingBars.forEach((el) => el.style.setProperty("margin-left", "0", "important"))
          } else if (attributeRatingsValue > 0.15 && attributeRatingsValue <= 0.5) { // runs a bit big
            shadingBars.forEach((el) => el.style.setProperty("margin-left", "calc( 75% - 15px)", "important"))
          } else if (attributeRatingsValue > 0.5 && attributeRatingsValue <= 1) { // runs big
            shadingBars.forEach((el) => el.style.setProperty("margin-left", "calc( 100% - 30px)", "important"))
          }

          shadingBars.forEach((el) => el.style.setProperty("transform", "none", "important"))
        }
      } catch (e) {
        console.error("Error parsing JSON from data-oke-metafield-data:", e)
      }
    }

    document.querySelector("#size-guide-fit-review").classList.remove("hidden")

    const fitLink = document.querySelector("#size-guide-fit-review .fit-link")
    if (fitLink) {
      fitLink.addEventListener("click", function () {
        closeSizeGuideModal(sizeGuidePopup)
      })
    }
  })
}

const sizeGuideCache = new Map()
const sizeGuideRequests = new Map()

const normalizeSizeGuideUrl = (url) => {
  try {
    return url ? new URL(url, window.location.origin).pathname : ""
  } catch (error) {
    return url
  }
}

const initializeSizeGuideContent = (root) => {
  initSizeGuideTabs(root)
  initChartSubtabs(root)
  initMeasureSubtabs(root)
  initUnitSwatch(root)
  initHowToMeasureButton(root)
  initSizeGuideChatTrigger(root)
  initMobileColumns(root)
  initNavigateAndOpen(root)
}

const setSizeGuideContent = (source) => {
  const content = source.cloneNode(true)
  // The fetched page is only a source of markup; its scripts must not execute.
  content.querySelectorAll("script").forEach((script) => script.remove())
  sizeGuidePopup.replaceChildren(...content.childNodes)

  for (const key of ["sizeGuideProductId", "sizeGuideProductTitle", "sizeGuideProductUrl"]) {
    if (source.dataset[key] != null) sizeGuidePopup.dataset[key] = source.dataset[key]
  }

  initializeSizeGuideContent(sizeGuidePopup)
}

const loadProductSizeGuide = (requestedUrl, productId) => {
  const requestedPath = normalizeSizeGuideUrl(requestedUrl)
  if (sizeGuideCache.has(requestedPath)) return Promise.resolve(sizeGuideCache.get(requestedPath))
  if (sizeGuideRequests.has(requestedPath)) return sizeGuideRequests.get(requestedPath)

  const request = (async () => {
    // Fetch the actual product page so Shopify uses its assigned JSON template,
    // including that template's configured size_guide block and garment table.
    const productUrl = new URL(requestedUrl, window.location.origin)
    if (productUrl.origin !== window.location.origin) throw new Error("Invalid size guide origin")
    const previewThemeId = new URLSearchParams(window.location.search).get("preview_theme_id")
    if (previewThemeId) productUrl.searchParams.set("preview_theme_id", previewThemeId)

    const response = await fetch(productUrl.toString(), {
      headers: { Accept: "text/html" },
      credentials: "same-origin",
    })
    if (!response.ok) throw new Error(`Size guide request failed with ${response.status}`)

    const html = await response.text()
    const productDocument = new DOMParser().parseFromString(html, "text/html")
    const guide = Array.from(productDocument.querySelectorAll(".size-guide")).find((candidate) => (
      candidate.dataset.sizeGuideProductId === productId && candidate.querySelector(".guide-table table")
    ))
    if (!guide) throw new Error(`No configured size guide found for ${requestedPath}`)

    sizeGuideCache.set(requestedPath, guide)
    return guide
  })()

  sizeGuideRequests.set(requestedPath, request)
  request.finally(() => sizeGuideRequests.delete(requestedPath)).catch(() => {})
  return request
}

const fetchSizeGuideForProduct = async (button) => {
  if (!sizeGuidePopup) return
  const requestId = ++sizeGuideRequestId

  const requestedUrl = button.dataset.sizeGuideProductUrl
  if (!requestedUrl) {
    openSizeGuideModal(sizeGuidePopup)
    return
  }

  const requestedPath = normalizeSizeGuideUrl(requestedUrl)
  const currentPath = normalizeSizeGuideUrl(sizeGuidePopup.dataset.sizeGuideProductUrl || "")

  if (requestedPath === currentPath) {
    openSizeGuideModal(sizeGuidePopup)
    return
  }

  const label = button.textContent
  const errorContainer = button.closest(".product-form__input") || button.parentElement
  errorContainer.querySelector("[data-size-guide-error]")?.remove()
  button.textContent = "Loading…"
  button.classList.add("loading")
  button.setAttribute("aria-busy", "true")

  try {
    const nextGuide = await loadProductSizeGuide(requestedUrl, button.dataset.sizeGuideProductId)
    if (requestId !== sizeGuideRequestId) return
    setSizeGuideContent(nextGuide)
    openSizeGuideModal(sizeGuidePopup)
  } catch (error) {
    if (requestId !== sizeGuideRequestId) return
    console.error("Unable to load product size guide.", error)
    const message = document.createElement("p")
    message.dataset.sizeGuideError = ""
    message.setAttribute("role", "alert")
    message.textContent = "Unable to load the size guide. Please try again."
    errorContainer.appendChild(message)
  } finally {
    button.textContent = label
    button.classList.remove("loading")
    button.removeAttribute("aria-busy")
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (sizeGuidePopup) {
    const currentPath = normalizeSizeGuideUrl(sizeGuidePopup.dataset.sizeGuideProductUrl || "")
    if (currentPath && sizeGuidePopup.querySelector(".guide-table table")) {
      sizeGuideCache.set(currentPath, sizeGuidePopup.cloneNode(true))
    }

    document.addEventListener("click", (event) => {
      const button = event.target.closest(".size-guide-btn")
      if (!button) return

      event.preventDefault()
      if (button.hasAttribute("aria-busy")) return
      fetchSizeGuideForProduct(button)
    })

    sizeGuidePopup.addEventListener("click", function (e) {
      if (e.target.closest(".size-guide__close")) {
        closeSizeGuideModal(sizeGuidePopup)
        return
      }
      if (e.target === this) closeSizeGuideModal(sizeGuidePopup)
    })
    window.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeSizeGuideModal(sizeGuidePopup)
    })

    initializeSizeGuideContent(sizeGuidePopup)

    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get("openSizeGuide") === "true") {
      setTimeout(() => openSizeGuideModal(sizeGuidePopup), 600)
    }
  }
  initOkendoFitReview()
})
